import { AuthService } from '@services/auth.service';
import { ClientsService } from '@services/clients.service';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { Contact } from '@classes/contact';
import { ContactsService } from '@services/contacts.service';
import { Client } from '@classes/client';

@Component({
  selector: 'app-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss']
})
export class ContactEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() contact: Contact;

  clients: Client[] = [];
  clientsUser: string[] = [];
  withOneClient: boolean;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private contactsSrv: ContactsService,
    private clientsSrv: ClientsService,
    private authSrv: AuthService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();

    let clients = [];
    clients = this.authSrv.getDecodedToken().client.split(',');
    this.clientsUser = clients;


    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;
    this.clientsSrv.getList().subscribe(clientsFromSrv => {
      this.clients = clientsFromSrv;
      this.isLoading = false;

      if (this.clients.length > 1) {
        this.withOneClient = false;
      } else {
        this.withOneClient = true;
      }

      this.initForm();
    });
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.contact) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const contactCopy: Contact = JSON.parse(JSON.stringify(this.contact));
    contactCopy.client = this.editForm.value.client;
    contactCopy.firstname = this.editForm.value.firstname;
    contactCopy.lastname = this.editForm.value.lastname;
    contactCopy.phone = this.editForm.value.phone;
    contactCopy.gsm = this.editForm.value.gsm;
    contactCopy.email = this.editForm.value.email;
    contactCopy.fax = this.editForm.value.fax;
    contactCopy.locality = this.editForm.value.locality;
    contactCopy.postalCode = this.editForm.value.postalCode;
    contactCopy.street = this.editForm.value.street;
    contactCopy.streetNumber = this.editForm.value.streetNumber;
    contactCopy.service = this.editForm.value.service;
    contactCopy.site = this.editForm.value.site;

    this.contactsSrv.put(contactCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.contact = new Contact(
      this.editForm.value.client,
      this.editForm.value.firstname,
      this.editForm.value.lastname,
      this.editForm.value.phone,
      this.editForm.value.gsm,
      this.editForm.value.email,
      this.editForm.value.fax,
      this.editForm.value.locality,
      this.editForm.value.postalCode,
      this.editForm.value.street,
      this.editForm.value.streetNumber,
      this.editForm.value.service,
      this.editForm.value.site
    );

    this.contactsSrv.post(this.contact)
      .subscribe(
        () => this.isLoading = false,
        () => this.contact = null
      );
  }

  private initForm(): void {
    let client = null;
    let firstname = "";
    let lastname = "";
    let phone = "";
    let gsm = "";
    let email = "";
    let fax = "";
    let locality = "";
    let postalCode = "";
    let street = "";
    let streetNumber = "";
    let service = "";
    let site = "";

    if (this.contact) {
      client = this.contact.client;
      firstname = this.contact.firstname;
      lastname = this.contact.lastname;
      phone = this.contact.phone;
      gsm = this.contact.gsm;
      email = this.contact.email;
      fax = this.contact.fax;
      locality = this.contact.locality;
      postalCode = this.contact.postalCode;
      street = this.contact.street;
      streetNumber = this.contact.streetNumber;
      service = this.contact.service;
      site = this.contact.site;
    } else {
      if (this.withOneClient) {
        this.clients.map(oneClient => {
          if (oneClient.name === this.clientsUser[0]) {
            client = oneClient;
          }
        })
      }
    }

    this.editForm = this.fb.group({
      client: [client, Validators.required],
      firstname: [firstname, Validators.required],
      lastname: [lastname],
      gsm: [gsm],
      email: [email, [Validators.email]],
      phone: [phone],
      fax: [fax],
      locality: [locality],
      postalCode: [postalCode],
      street: [street],
      streetNumber: [streetNumber],
      service: [service],
      site: [site]
    });
  }
}
